// Sales method
const SALES_METHOD = {
  NORMAL: 'normal',
  BTO: 'bto',
  CONSIGNMENT: 'consignment',
  PRE_ORDER: 'pre_order'
};

// Sales method の enum 用定義
const SALES_METHOD_PATTERN = Object.keys(SALES_METHOD).map(
  (key) => SALES_METHOD[key]
);

// Payment method
const PAYMENT_METHOD = {
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
  AMAZON: 'amazon',
  CONVENIENCE_STORE: 'convenience_store',
  BYPASS: 'bypass',
  MOBILE: 'mobile'
};

// Payment method の enum 用定義
const PAYMENT_METHOD_PATTERN = Object.keys(PAYMENT_METHOD).map(
  (key) => PAYMENT_METHOD[key]
);

const SHIPMENT_TYPE = {
  DIGITAL_PRODUCT: 'digital_product',
  NO_MIXED_LOADING: 'no_mixed_loading',
  PRE_ORDER_PRODUCT: 'pre_order_product',
  BTO_PRODUCT: 'bto_product',
  NORMAL_PRODUCT: 'normal_product'
};

const SHIPMENT_TYPE_PATTERN = Object.keys(SHIPMENT_TYPE).map(
  (key) => SHIPMENT_TYPE[key]
);

// 英数記号、ひらがな、カタカナ、漢字、全角英数記号
// 参考: http://tama-san.com/?p=196
//       http://kourge.net/projects/regexp-unicode-block
const GIFT_MESSAGE_REGEXP = /^(?:[\u0000-\u00FF\u3000-\u30FF\u3400-\u9FFF\uF900-\uFAFF\uFF00-\uFFFF]|[\uD840-\uD87F][\uDC00-\uDFFF])*$/; // eslint-disable-line
const GIFT_MESSAGE_MAX_LENGTH = 48;

const CREDIT_CARD_BRAND_DATA = [{
    name: 'VISA',
    imageUrl: '/static/common/icons/card_visa.png'
  },
  {
    name: 'Master Card',
    imageUrl: '/static/common/icons/card_master.png'
  },
  {
    name: 'AMERICAN EXPRESS',
    imageUrl: '/static/common/icons/card_amex.png'
  },
  {
    name: 'JCB',
    imageUrl: '/static/common/icons/card_jcb.png'
  },
  {
    name: 'DISCOVER',
    imageUrl: '/static/common/icons/card_discover.png'
  },
  {
    name: 'Diners Club',
    imageUrl: '/static/common/icons/card_diners.png'
  }
];

const COUPON_TYPE = {
  AMOUNT_OFF: 1,
  PERCENT_OFF: 2
};

// ref: lib/document/ShoppingCoupons.js:86
const WELCOMING_GIFT = {
  DISPLAY_NAME: 'Welcoming Gift',
  WELCOMING_GIFT_AMOUNT_OFF: 7
};

const PURCHASE_LIMIT_FOR_MANGA_PLUS = 6;

export {
  SALES_METHOD,
  SALES_METHOD_PATTERN,
  PAYMENT_METHOD,
  PAYMENT_METHOD_PATTERN,
  SHIPMENT_TYPE,
  SHIPMENT_TYPE_PATTERN,
  GIFT_MESSAGE_REGEXP,
  GIFT_MESSAGE_MAX_LENGTH,
  CREDIT_CARD_BRAND_DATA,
  COUPON_TYPE,
  WELCOMING_GIFT,
  PURCHASE_LIMIT_FOR_MANGA_PLUS
};
